@app.service 'ssoService', ($http, $q, localStorageService, $location)->

  @complete = false

  @isZendesk = ->
    rt = $location.search().return_to
    rt? && (rt.indexOf('zendesk') != -1 || rt.indexOf('support.chefsteps.com') != -1)

  @isFBMessenger = ->
    rt = $location.search().path
    rt? && (rt.indexOf('fbid=') != -1)

  @isAmazon = ->
    rt = $location.search().path
    rt? && (rt.indexOf('amazon') != -1 || rt.indexOf('pitangui.amazon.com') != -1)

  @signAndRedirect = (state) ->
    deferred = $q.defer()
    userToken = localStorageService.get('user.token')

    config =
      params:
        # Shopify and Alexa use 'path', zendesk 'return_to'
        path: $location.search().path || $location.search().return_to
        state: state
      headers: { 'Authorization': 'Bearer ' + userToken }

    $http.get("#{csConfig.chefstepsEndpoint}/api/v0/auth/external_redirect", config).then ((response) =>

      if response.data.close
        # Used for sign in to services that aren't in browser, like our FB messenger bot
        $http.get(response.data.redirect).then((response2) =>
          deferred.resolve()
          # window.close may be prevented; if so ignore and the form will give
          # them the option to close with a click.
          @complete = true
          try window.close() catch
        , (error) ->
          console.log('Error', error)
          deferred.reject('There was an error while processing your request.')
        )

      else
        # Typical case, send browser back to where the user needed to sign in
        @complete = true
        deferred.resolve()
        window.location = response.data.redirect

    ), (error) ->
      deferred.reject('There was an error while processing your request.')

    deferred.promise

  @signAndUpgradeToken = (token,redirect) =>
    deferred = $q.defer()

    config =
      headers: { 'Authorization': 'Bearer ' + token }

    # Authenticates with the short lived token
    $http.post("#{csConfig.chefstepsEndpoint}/api/v0/upgrade_token", {}, config).then ((response) =>
      upgraded_token = response.data.token
      # Successful upgrade of token will not be used
      localStorageService.set('user.token',upgraded_token)
      deferred.resolve()

      @redirectOrRoot(redirect)

    ), (error) ->
      deferred.reject('There was an error while processing your request.')

    deferred.promise

  @redirectOrRoot = (redirect_url) ->
    if redirect_url
      window.location = redirect_url
    else
      window.location = csConfig.chefstepsEndpoint

  this
